import React, { memo } from 'react';
import './TabPanel.css';

const TabPanel = memo(({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`tab-panel ${className}`}>
      {children}
    </div>
  );
});

TabPanel.displayName = 'TabPanel';

export default TabPanel;
